import Vue from 'vue'
import Vuex from 'vuex'
import atmStore from './atmStoreModule'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {

  },
  getters:{

  },
  mutations: {

  },
  actions: {

  },
  modules:{
    atmStore
  }
})
export default store